import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import useSetState from 'hooks/useSetState'
import { digObject } from 'functions/utilities'

const isSectionEnabled = (dataSource, sectionId) => {
  const disabledSections = digObject(dataSource, 'options.disabled_sections', [])

  return !disabledSections.includes(sectionId)
}

const toggleSection = (context, props, setState) => {
  const { sectionId } = props

  const {
    callbacks: { updateCampaignProposal, updateDigitalPage },
    dataSource: { id, options },
    dataSourceType,
  } = context

  setState({ updating: true })

  const updatedOptions = { ...options }
  const disabledSections = updatedOptions.disabled_sections ? [...updatedOptions.disabled_sections] : []

  const index = disabledSections.indexOf(sectionId)
  if (index === -1){
    disabledSections.push(sectionId)
  } else {
    disabledSections.splice(index, 1)
  }

  updatedOptions.disabled_sections = disabledSections

  const updatedDataSource = {
    id,
    options: JSON.stringify(updatedOptions),
  }

  const updateFn = dataSourceType === 'CampaignProposal' ? updateCampaignProposal : updateDigitalPage

  updateFn(updatedDataSource).then(() => {
    setState({
      updating: false,
    })
  })
}

const defaultState = {
  updating: false,
}

const ToggleableSectionWrapper = (props) => {
  const [state, setState] = useSetState(defaultState)
  const { updating } = state

  const { render, sectionId } = props

  const defaultContext = useContext(GlobalContext)
  const { dataSource, editing } = defaultContext

  const enabled = isSectionEnabled(dataSource, sectionId)
  if (!editing && !enabled){
    return null
  }

  return render({
    editing,
    enabled,
    toggleSection: () => toggleSection(defaultContext, props, setState),
    updating,
  })
}

ToggleableSectionWrapper.propTypes = {
  render: PropTypes.func.isRequired,
  sectionId: PropTypes.string.isRequired,
}

export default ToggleableSectionWrapper
